import { LOCATION_TYPE } from '~/constants/vCard';

const hasAddress = (location) => {
  const { url, street, city, latitude, longitude } = location;

  if (location.type === LOCATION_TYPE.FULL) {
    return !!(street && city);
  }

  if (location.type === LOCATION_TYPE.URL) {
    return !!url;
  }

  return !!(latitude && longitude);
};

export const transformValuesToContent = (values) => {
  const { location, firstName, lastName, email, website, companyName, companyPosition, phones } = values;
  const { street, postalCode, number, city, state, country, latitude, longitude, url, type } = location;

  return {
    firstName,
    lastName,
    email,
    website,
    companyName,
    companyPosition,
    phones,
    location: {
      url: url || null,
      type: hasAddress(location) ? type : null,
      street: street || '',
      number: number || null,
      city: city || '',
      state: state || '',
      postalCode: postalCode || '',
      country: country || '',
      latitude: latitude || '',
      longitude: longitude || '',
      street_number_first: false,
      location_visibility: 'SHOW_ADDRESS_LINK',
    },
  };
};

export const transformContentToFormValues = (content) => {
  const { firstName, lastName, email, website, companyName, companyPosition, phones, location } = content;
  const { type, url, longitude, latitude, street, number, postalCode, city, state, country } = location;

  return {
    location: {
      street: street || '',
      postalCode: postalCode || '',
      number: number || undefined,
      city: city || '',
      state: state || '',
      country: country || '',
      latitude: latitude || '',
      longitude: longitude || '',
      url: url || '',
      type: type || '',
    },
    firstName: firstName || '',
    lastName: lastName || '',
    email: email || '',
    website: website || '',
    companyName: companyName || '',
    companyPosition: companyPosition || '',
    phones: phones || [],
  };
};
